var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.displaySection()
        ? _c(
            "button",
            {
              staticClass: "btn btn-info btn-block",
              on: {
                click: function($event) {
                  return _vm.openUpdateServiceDateTimeModal()
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("message.button.select_service_datetime")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("select-service-date-time-modal", {
        ref: "selectServiceDateTimeModal",
        attrs: { order: _vm.order }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d2a65c9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2a65c9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/SelectServiceDateTimeSection.vue
// module id = 1766
// module chunks = 0